module.exports = __webpack_public_path__ + "static/media/askey1.f01b4555.gif";